const translations = {
  en: {
    bulk_all: "All",
    bulk_exhibit_label: "Exhibit", bulk_repair_label: "Repair",
    bulk_repairing: "Repairing",
    bulk_exhibiting: "Exhibiting",
    bulk_repaired: "Repaired {n} paintings (−{spent} coins)",
    bulk_exhibited: "Exhibiting {n} paintings",
    bulk_skipped: "{n} paintings skipped — not enough coins",
    bulk_no_coins: "Not enough coins to repair",
    bulk_slots_full: "All exhibit slots are busy",
    coll_loading: "Loading…",
    coll_new: "New collection",
    coll_name_placeholder: "Collection name",
    coll_create: "Create",
    coll_creating: "Creating…",
    coll_cancel: "Cancel",
    coll_need_coins: "Costs {cost} coins — you're {n} short",
    coll_coins_short: "{n} coins short",
    coll_created: "Collection “{name}” created",
    coll_deleted: "Collection “{name}” deleted",
    coll_create_failed: "Could not create",
    coll_empty_hint: "Collections showcase your paintings. They stay in your gallery and keep earning.",
    buff_load_failed: "Could not load the bonus. Flip back and try again.",
    rarity_common: "Common",
    rarity_uncommon: "Uncommon",
    rarity_rare: "Rare",
    rarity_legendary: "Legendary",
    rarity_masterpiece: "Masterpiece",
    buff_title: "Set Bonuses",
    buff_in_collection: "In collection",
    buff_total: "Total bonus",
    buff_applies: "Boosts exhibit coins and influence XP",
    buff_per_hour: "coins/h at current condition",
    buff_no_collection: "Not in a collection",
    buff_no_collection_hint: "Place this painting in a collection — paintings that share an artist, a year, a rarity, or Unique / TON status boost each other.",
    buff_no_sets: "No set bonuses yet",
    buff_no_sets_hint: "Add a painting by the same artist or from the same year to start earning.",
    buff_rules: "Same artist or year: from 2 paintings. Same rarity: from 5. Unique +5% each, TON +1% each. All bonuses stack.",
    set_artist: "Artist",
    set_year: "Year",
    set_rarity: "Rarity",
    set_unique: "Unique",
    set_ton: "TON",
    // Nav
    collection: "Collection", gallery: "Gallery", earn: "Earn", upgrades: "Upgrades", top: "Top", auction: "Auction", profile: "Profile",
    // Header
    balance: "Bank",
    // Gallery
    no_paintings_yet: "No paintings yet",
    buy_random_desc: "Buy a random painting or invite friends to get paintings in your collection!",
    buy_random: "Buy Random Painting", buy_random_card: "Buy Random Painting", for_price: "for",
    reel_roll_for: "Roll for",
    reel_purchase_failed: "Purchase failed",
    reel_loading: "Loading…",
    reel_unavailable: "No paintings available",
    reel_you_got: "You got: {title}",
    reel_continue: "Continue",
    reel_spinning: "Spinning…",
    reel_need_more: "Need {n} more coins",
    reel_free_painting: "Free painting",
    exhibit: "Exhibit", repair: "Repair", details: "Details", burn: "Burn",
    exhibited: "Exhibited", collect_reward: "Collect Reward",
    choose_duration: "Choose exhibition duration",
    cancel: "Cancel",
    all_slots_busy: "All exhibit slots used. Upgrade to exhibit more.",
    card_destroyed: "Painting destroyed (0% condition)",
    not_enough_coins: "Not enough coins",
    free: "Free",
    adding: "Adding...", added: "Added!",
    rarity: "Rarity", condition: "Condition", supply: "Supply", influence: "Influence",
    open_post: "Open Post", buff: "Buff", coming_soon: "Coming soon!",
    swipe_hint: "Swipe to explore gallery", tap_hint: "Tap the painting",
    // Exhibit cities
    exhibited_in_paris: "Exhibited in Paris", exhibited_in_new_york: "Exhibited in New York",
    exhibited_in_london: "Exhibited in London", exhibited_in_rome: "Exhibited in Rome",
    exhibited_in_berlin: "Exhibited in Berlin", exhibited_in_tokyo: "Exhibited in Tokyo",
    exhibited_in_madrid: "Exhibited in Madrid", exhibited_in_vienna: "Exhibited in Vienna",
    exhibited_in_amsterdam: "Exhibited in Amsterdam", exhibited_in_budapest: "Exhibited in Budapest",
    exhibited_in_dubai: "Exhibited in Dubai", exhibited_in_florence: "Exhibited in Florence",
    exhibited_in_los_angeles: "Exhibited in Los Angeles", exhibited_in_prague: "Exhibited in Prague",
    exhibited_in_milan: "Exhibited in Milan", exhibited_in_barcelona: "Exhibited in Barcelona",
    exhibited_in_zurich: "Exhibited in Zurich", exhibited_in_seoul: "Exhibited in Seoul",
    exhibited_in_istanbul: "Exhibited in Istanbul", exhibited_in_copenhagen: "Exhibited in Copenhagen",
    exhibited_in_singapore: "Exhibited in Singapore",
    // Earn
    discover_art: "Discover Private Art", daily_tasks: "Daily Tasks",
    refresh_in: "Refresh in", skip: "Skip",
    coins: "coins", today: "today", per_friend: "per friend",
    claim: "Claim", claimed: "Claimed",
    invite_friends: "Invite Friends",
    friends_income_desc: "+2% of friend's income from exhibitions",
    friends_invited: "Friends Invited", income_from_friends: "Income from Friends",
    daily_bonus: "Daily Bonus", consecutive_days: "Consecutive Days",
    next_bonus: "Next Bonus", claim_bonus: "Claim Bonus",
    complete_all: "Complete all daily tasks", all_tasks: "All Tasks Bonus",
    discover: "Discover", achievements: "Achievements",
    collect_5_artist: "Collect 5 paintings by same artist",
    collect_5_year: "Collect 5 paintings from same year",
    same_artist: "Same Artist", same_year: "Same Year",
    claim_rewards: "Claim Rewards",
    subscribe_channel: "Subscribe Channel",
    subscribe_desc: "Subscribe to @privateart and earn coins",
    subscribe_btn: "Subscribe",
    boost_channel: "Boost Channel", boost_desc: "Boost @privateart channel",
    boost_btn: "Boost", per_boost: "per boost",
    gift_channel: "Gift Channel",
    gift_desc: "Send a gift to @privateart and earn coins",
    gift_btn: "Send Gift",
    one_time: "one-time",
    discover_3_ref: "Invite 3 friends",
    discover_5: "Discover 5 paintings",
    // Upgrades
    max_level: "MAX",
    // Profile
    delete_account: "Delete Account",
    delete_confirm: "Delete account? All data will be lost permanently!",
    total_rating: "Total Rating", your_rank: "Your Rank",
    // Auction
    auction_desc: "Here you will be able to sell your paintings to other players for Telegram Stars. The auction will open when 10 Masterpiece paintings exist in the game.",
    masterpiece_count: "Masterpiece paintings in game",
    // Leaderboard
    leaderboard: "Leaderboard",
    // TON Wallet
    ton_wallet: "TON Wallet",
    connect_ton_wallet: "Connect TON Wallet",
    ton_wallet_hint: "Connect your TON wallet to mint paintings as dynamic NFTs (25 ⭐).",
    wallet_connected: "TON wallet connected",
    wallet_disconnected: "TON wallet disconnected",
    connected: "Connected",
    disconnect: "Disconnect",
    copied: "Copied",
    mint_nft: "Mint TON Artwork",
    minted_on_ton: "Minted on TON",
    your_nfts: "Your TON Artworks",
    sync_nfts_from_wallet: "Sync TON from wallet",
    repair_free: "Free",
    no_influence_paintings: "No paintings with influence yet. Start exhibiting!",
    today_bonus: "Today's bonus",
    next_bonus: "Next bonus",
    streak_tooltip: "Streak: {n} day{s} in a row (best: {best})",
    syncing: "Syncing...",
    refresh_metadata_btn: "Force refresh",
    refreshing: "Refreshing...",
    refresh_metadata_hint: "Force NFT metadata refresh in wallets (Tonkeeper, etc.)",
    refresh_metadata_done: "Server cache nudged for {n} NFT(s). Pull-to-refresh in Tonkeeper to see updated Level.",
    no_nfts_to_refresh: "No minted NFTs yet",
    no_nfts_in_wallet: "No NFTs from this collection in your wallet",
    nft_wallet_note: "Telegram Wallet caches NFTs slowly — these always show your real on-chain holdings.",
    // Tooltip
    total_influence: "Sum of the influence of your paintings",
    // Onboarding
    welcome: "Welcome!", first_painting: "Your first painting awaits",
    tap_to_reveal: "Tap to reveal", skip_onboard: "Skip", continue_btn: "Continue",
    // Misc
    loading: "Loading...", error: "Error", retry: "Retry",
    stars_payment: "Payment via Telegram Stars",
    collect_painting: "Collect painting",
    add_to_collection: "Add to Collection", new_card: "New Painting!",
    no_cards: "No paintings yet", buy: "Buy", cards: "Paintings",
    language: "Language", owner: "Owner",
    same_artist_5: "Same Artist x5", same_year_5: "Same Year x5",
    // Tooltips & Details
    your_coins: "Your coins", painting_slots: "Painting slots",
    slots_full: "All slots full. Upgrade painting slots",
    supply_tooltip: "How many of this painting at this rarity exist",
    rarity_thresholds: "Rarity thresholds",
    condition_tooltip: "Condition degrades over time. Repair the painting to restore it",
    max_rarity: "Max level reached!",
    sell: "Sell", sell_masterpiece_only: "Only Masterpiece paintings can be sold",
    collect: "Collect",
    platinum: "Platinum", gold: "Gold", bronze: "Bronze",
    year: "Year", rating: "Rating",
    hours_short: "h",
    // Tutorial dialogs
    tut_details: "Let's find out what kind of painting this is. Some paintings may worth a lot!",
    tut_repair: "Press to repair",
    tut_exhibit: "Click to start earning coins",
    tut_exhibit_pick: "While your painting is on display, it gains influence and income. Influence increases the painting's level, which generates higher rewards.",
    tut_buy: "Now let's buy another painting — you never know what you'll get. Good luck!",
    level_upgraded: "Painting level upgraded",
    exhibited: "Exhibited", collect_reward: "Collect Reward",
    details: "Details", buff: "Buff", coming_soon_text: "Coming soon...",
    view_post: "View Post", repair: "Repair",
  },
  ru: {
    bulk_all: "Все",
    bulk_exhibit_label: "Выставить", bulk_repair_label: "Починить",
    bulk_repairing: "Ремонтируем",
    bulk_exhibiting: "Выставляем",
    bulk_repaired: "Отремонтировано картин: {n} (−{spent} монет)",
    bulk_exhibited: "Выставлено картин: {n}",
    bulk_skipped: "Пропущено картин: {n} — не хватило монет",
    bulk_no_coins: "Не хватает монет на ремонт",
    bulk_slots_full: "Все слоты выставки заняты",
    coll_loading: "Загрузка…",
    coll_new: "Новая коллекция",
    coll_name_placeholder: "Название коллекции",
    coll_create: "Создать",
    coll_creating: "Создаём…",
    coll_cancel: "Отмена",
    coll_need_coins: "Нужно {cost} монет — не хватает {n}",
    coll_coins_short: "Не хватает {n} монет",
    coll_created: "Коллекция «{name}» создана",
    coll_deleted: "Коллекция «{name}» удалена",
    coll_create_failed: "Не удалось создать",
    coll_empty_hint: "Коллекции — витрина твоих картин. Картины остаются в галерее и продолжают приносить доход.",
    buff_load_failed: "Не удалось загрузить бонус. Переверните карточку ещё раз.",
    rarity_common: "Обычная",
    rarity_uncommon: "Необычная",
    rarity_rare: "Редкая",
    rarity_legendary: "Легендарная",
    rarity_masterpiece: "Шедевр",
    buff_title: "Бонусы коллекции",
    buff_in_collection: "В коллекции",
    buff_total: "Общий бонус",
    buff_applies: "Увеличивает монеты с выставки и influence XP",
    buff_per_hour: "монет/ч при текущем состоянии",
    buff_no_collection: "Не в коллекции",
    buff_no_collection_hint: "Добавьте картину в коллекцию — картины с общим художником, годом, редкостью или статусом Unique / TON усиливают друг друга.",
    buff_no_sets: "Бонусов пока нет",
    buff_no_sets_hint: "Добавьте картину того же художника или того же года, чтобы бонус заработал.",
    buff_rules: "Один художник или год — от 2 картин. Одна редкость — от 5. Unique +5% за картину, TON +1%. Все бонусы складываются.",
    set_artist: "Художник",
    set_year: "Год",
    set_rarity: "Редкость",
    set_unique: "Unique",
    set_ton: "TON",
    collection: "Коллекция", gallery: "Галерея", earn: "Заработать", upgrades: "Прокачка", top: "Топ", auction: "Аукцион", profile: "Профиль",
    balance: "Баланс",
    no_paintings_yet: "Пока нет картин",
    buy_random_desc: "Купите случайную картину или пригласите друзей чтобы начать коллекцию!",
    buy_random: "Купить картину", buy_random_card: "Купить картину", for_price: "за",
    reel_roll_for: "Крутить за",
    reel_purchase_failed: "Покупка не удалась",
    reel_loading: "Загрузка…",
    reel_unavailable: "Картины недоступны",
    reel_you_got: "Вы получили: {title}",
    reel_continue: "Забрать",
    reel_spinning: "Крутим…",
    reel_need_more: "Нужно ещё {n} монет",
    reel_free_painting: "Бесплатная картина",
    exhibit: "Выставить", repair: "Починить", details: "Детали", burn: "Сжечь",
    exhibited: "На выставке", collect_reward: "Забрать награду",
    choose_duration: "Выберите длительность выставки",
    cancel: "Отмена",
    all_slots_busy: "Все слоты заняты. Улучшите слоты в Прокачке",
    card_destroyed: "Картина уничтожена (0% состояния)",
    not_enough_coins: "Недостаточно монет",
    free: "Бесплатно",
    adding: "Добавляем...", added: "Добавлено!",
    rarity: "Уровень", condition: "Состояние", supply: "Тираж", influence: "Влияние",
    open_post: "Открыть пост", buff: "Бафф", coming_soon: "Скоро!",
    swipe_hint: "Свайпайте чтобы исследовать галерею", tap_hint: "Нажмите на картину",
    exhibited_in_paris: "Выставка в Париже", exhibited_in_new_york: "Выставка в Нью-Йорке",
    exhibited_in_london: "Выставка в Лондоне", exhibited_in_rome: "Выставка в Риме",
    exhibited_in_berlin: "Выставка в Берлине", exhibited_in_tokyo: "Выставка в Токио",
    exhibited_in_madrid: "Выставка в Мадриде", exhibited_in_vienna: "Выставка в Вене",
    exhibited_in_amsterdam: "Выставка в Амстердаме", exhibited_in_budapest: "Выставка в Будапеште",
    exhibited_in_dubai: "Выставка в Дубае", exhibited_in_florence: "Выставка во Флоренции",
    exhibited_in_los_angeles: "Выставка в Лос-Анджелесе", exhibited_in_prague: "Выставка в Праге",
    exhibited_in_milan: "Выставка в Милане", exhibited_in_barcelona: "Выставка в Барселоне",
    exhibited_in_zurich: "Выставка в Цюрихе", exhibited_in_seoul: "Выставка в Сеуле",
    exhibited_in_istanbul: "Выставка в Стамбуле", exhibited_in_copenhagen: "Выставка в Копенгагене",
    exhibited_in_singapore: "Выставка в Сингапуре",
    discover_art: "Открой Private Art", daily_tasks: "Ежедневные задания",
    refresh_in: "Обновление через", skip: "Пропустить",
    coins: "монет", today: "сегодня", per_friend: "за друга",
    claim: "Забрать", claimed: "Получено",
    invite_friends: "Пригласить друзей",
    friends_income_desc: "+2% от дохода друга с выставок",
    friends_invited: "Друзей приглашено", income_from_friends: "Доход от друзей",
    daily_bonus: "Ежедневный бонус", consecutive_days: "Дней подряд",
    next_bonus: "Следующий бонус", claim_bonus: "Получить бонус",
    complete_all: "Выполните все задания дня", all_tasks: "Бонус за все задания",
    discover: "Открыть", achievements: "Достижения",
    collect_5_artist: "Собрать 5 картин одного художника",
    collect_5_year: "Собрать 5 картин одного года",
    same_artist: "Один художник", same_year: "Один год",
    claim_rewards: "Забрать награды",
    subscribe_channel: "Подписка на канал",
    subscribe_desc: "Подпишитесь на @privateart и получите монеты",
    subscribe_btn: "Подписаться",
    boost_channel: "Буст канала", boost_desc: "Бустните канал @privateart",
    boost_btn: "Бустнуть", per_boost: "за буст",
    gift_channel: "Подарок каналу",
    gift_desc: "Подарите гифт каналу @privateart",
    gift_btn: "Подарить",
    one_time: "одноразово",
    discover_3_ref: "Пригласить 3 друзей",
    discover_5: "Открыть 5 картин",
    max_level: "МАКС",
    delete_account: "Удалить аккаунт",
    delete_confirm: "Удалить аккаунт? Все данные будут потеряны навсегда!",
    total_rating: "Общий рейтинг", your_rank: "Ваше место",
    auction_desc: "Здесь вы сможете продавать свои картины другим игрокам за Telegram Stars. Аукцион откроется, когда в игре появится 10 картин со статусом Masterpiece.",
    masterpiece_count: "Картин Masterpiece в игре",
    leaderboard: "Рейтинг",
    // TON Wallet
    ton_wallet: "TON-кошелёк",
    connect_ton_wallet: "Подключить TON-кошелёк",
    ton_wallet_hint: "Подключите TON-кошелёк, чтобы минтить картины как динамические NFT (25 ⭐).",
    wallet_connected: "TON-кошелёк подключён",
    wallet_disconnected: "TON-кошелёк отключён",
    connected: "Подключён",
    disconnect: "Отключить",
    copied: "Скопировано",
    mint_nft: "Создать TON Artwork",
    minted_on_ton: "NFT на TON",
    your_nfts: "Твои TON Artworks",
    sync_nfts_from_wallet: "Подтянуть TON из кошелька",
    repair_free: "Бесплатно",
    no_influence_paintings: "Пока нет картин с влиянием. Выставляйте картины!",
    today_bonus: "Сегодняшний бонус",
    next_bonus: "Следующий бонус",
    streak_tooltip: "Стрик: {n} {dayWord} подряд (рекорд: {best})",
    syncing: "Синхронизация...",
    refresh_metadata_btn: "Обновить",
    refreshing: "Обновление...",
    refresh_metadata_hint: "Принудительно обновить метадату NFT в кошельках",
    refresh_metadata_done: "Сервер обновлён для {n} NFT. Свайпните вниз в Tonkeeper чтобы увидеть новый уровень.",
    no_nfts_to_refresh: "Пока нет заминтованных NFT",
    no_nfts_in_wallet: "В этом кошельке нет NFT из нашей коллекции",
    nft_wallet_note: "Telegram Wallet обновляет NFT медленно — здесь всегда твои реальные NFT из блокчейна.",
    total_influence: "Сумма влияния всех ваших картин",
    welcome: "Добро пожаловать!", first_painting: "Ваша первая картина ждёт",
    tap_to_reveal: "Нажмите, чтобы открыть", skip_onboard: "Пропустить", continue_btn: "Продолжить",
    loading: "Загрузка...", error: "Ошибка", retry: "Повторить",
    stars_payment: "Оплата через Telegram Stars",
    collect_painting: "Забрать картину",
    add_to_collection: "Добавить в коллекцию", new_card: "Новая картина!",
    no_cards: "Пока нет картин", buy: "Купить", cards: "Картины",
    language: "Язык", owner: "Владелец",
    same_artist_5: "Один художник x5", same_year_5: "Один год x5",
    your_coins: "Ваши монеты", painting_slots: "Слоты для картин",
    slots_full: "Все слоты заняты. Улучшите слоты в Прокачке",
    supply_tooltip: "Сколько таких картин этого уровня в игре",
    rarity_thresholds: "Пороги уровней",
    condition_tooltip: "Состояние ухудшается со временем. Почините картину чтобы восстановить",
    max_rarity: "Максимальный уровень!",
    sell: "Продать", sell_masterpiece_only: "Только Masterpiece картины можно продавать",
    collect: "Забрать",
    platinum: "Платина", gold: "Золото", bronze: "Бронза",
    year: "Год", rating: "Рейтинг",
    hours_short: "ч",
    tut_details: "Давайте узнаем что за картина перед нами. Некоторые картины могут стоить целое состояние!",
    tut_repair: "Нажми, чтобы починить",
    tut_exhibit: "Нажми, чтобы начать зарабатывать монеты",
    tut_exhibit_pick: "Пока картина на выставке, она набирает влияние и доход. Влияние повышает уровень картины, что приносит больше наград.",
    tut_buy: "Теперь давайте купим ещё одну картину — никогда не знаешь что попадётся. Удачи!",
    level_upgraded: "Картина повысила уровень",
    exhibited: "На выставке", collect_reward: "Забрать награду",
    details: "Детали", buff: "Бафф", coming_soon_text: "Скоро...",
    view_post: "Открыть оригинал", repair: "Починить",
  },
  es: {
    bulk_all: "Todas",
    bulk_exhibit_label: "Exhibir", bulk_repair_label: "Restaurar",
    bulk_repairing: "Restaurando",
    bulk_exhibiting: "Exhibiendo",
    bulk_repaired: "Restauradas {n} pinturas (−{spent} monedas)",
    bulk_exhibited: "Exhibiendo {n} pinturas",
    bulk_skipped: "{n} pinturas omitidas: faltan monedas",
    bulk_no_coins: "No hay monedas suficientes para restaurar",
    bulk_slots_full: "Todas las ranuras de exhibición están ocupadas",
    coll_loading: "Cargando…",
    coll_new: "Nueva colección",
    coll_name_placeholder: "Nombre de la colección",
    coll_create: "Crear",
    coll_creating: "Creando…",
    coll_cancel: "Cancelar",
    coll_need_coins: "Cuesta {cost} monedas: te faltan {n}",
    coll_coins_short: "Te faltan {n} monedas",
    coll_created: "Colección «{name}» creada",
    coll_deleted: "Colección «{name}» eliminada",
    coll_create_failed: "No se pudo crear",
    coll_empty_hint: "Las colecciones exhiben tus pinturas. Siguen en tu galería y siguen generando ingresos.",
    buff_load_failed: "No se pudo cargar el bono. Gira la carta de nuevo.",
    rarity_common: "Común",
    rarity_uncommon: "Poco común",
    rarity_rare: "Rara",
    rarity_legendary: "Legendaria",
    rarity_masterpiece: "Obra maestra",
    buff_title: "Bonos de colección",
    buff_in_collection: "En la colección",
    buff_total: "Bono total",
    buff_applies: "Aumenta las monedas de exhibición y la influencia XP",
    buff_per_hour: "monedas/h con la condición actual",
    buff_no_collection: "Sin colección",
    buff_no_collection_hint: "Pon esta pintura en una colección: las obras que comparten artista, año, rareza o estado Unique / TON se potencian entre sí.",
    buff_no_sets: "Aún sin bonos",
    buff_no_sets_hint: "Añade una pintura del mismo artista o del mismo año para empezar a ganar.",
    buff_rules: "Mismo artista o año: desde 2 pinturas. Misma rareza: desde 5. Unique +5% cada una, TON +1%. Todos los bonos se suman.",
    set_artist: "Artista",
    set_year: "Año",
    set_rarity: "Rareza",
    set_unique: "Unique",
    set_ton: "TON",
    collection: "Coleccion", gallery: "Galeria", earn: "Ganar", upgrades: "Mejoras", top: "Top", auction: "Subasta", profile: "Perfil",
    balance: "Saldo",
    no_paintings_yet: "Aun no hay pinturas",
    buy_random_desc: "Compra una pintura aleatoria o invita amigos para empezar tu coleccion!",
    buy_random: "Comprar pintura", buy_random_card: "Comprar pintura",
    reel_roll_for: "Girar por",
    reel_purchase_failed: "La compra fallo",
    reel_loading: "Cargando…",
    reel_unavailable: "No hay pinturas disponibles",
    reel_you_got: "Obtuviste: {title}",
    reel_continue: "Continuar",
    reel_spinning: "Girando…",
    reel_need_more: "Necesitas {n} monedas mas",
    reel_free_painting: "Pintura gratis",
    exhibit: "Exhibir", repair: "Reparar", details: "Detalles", burn: "Quemar",
    exhibited: "En exposicion", collect_reward: "Cobrar recompensa",
    choose_duration: "Elige la duracion de la exposicion",
    cancel: "Cancelar",
    all_slots_busy: "Todos los espacios ocupados. Mejora para exhibir mas.",
    card_destroyed: "Pintura destruida (0% condicion)",
    not_enough_coins: "Monedas insuficientes",
    free: "Gratis",
    adding: "Agregando...", added: "Agregado!",
    rarity: "Nivel", condition: "Condicion", supply: "Tiraje", influence: "Influencia",
    open_post: "Abrir post", buff: "Buff", coming_soon: "Pronto!",
    swipe_hint: "Desliza para explorar la galeria", tap_hint: "Toca la pintura",
    exhibited_in_paris: "Expuesta en Paris", exhibited_in_new_york: "Expuesta en Nueva York",
    exhibited_in_london: "Expuesta en Londres", exhibited_in_rome: "Expuesta en Roma",
    exhibited_in_berlin: "Expuesta en Berlin", exhibited_in_tokyo: "Expuesta en Tokio",
    exhibited_in_madrid: "Expuesta en Madrid", exhibited_in_vienna: "Expuesta en Viena",
    exhibited_in_amsterdam: "Expuesta en Amsterdam", exhibited_in_budapest: "Expuesta en Budapest",
    exhibited_in_dubai: "Expuesta en Dubai", exhibited_in_florence: "Expuesta en Florencia",
    exhibited_in_los_angeles: "Expuesta en Los Angeles", exhibited_in_prague: "Expuesta en Praga",
    exhibited_in_milan: "Expuesta en Milan", exhibited_in_barcelona: "Expuesta en Barcelona",
    exhibited_in_zurich: "Expuesta en Zurich", exhibited_in_seoul: "Expuesta en Seul",
    exhibited_in_istanbul: "Expuesta en Estambul", exhibited_in_copenhagen: "Expuesta en Copenhague",
    exhibited_in_singapore: "Expuesta en Singapur",
    discover_art: "Descubre Private Art", daily_tasks: "Tareas diarias",
    refresh_in: "Actualiza en", skip: "Saltar",
    coins: "monedas", today: "hoy", per_friend: "por amigo",
    claim: "Cobrar", claimed: "Cobrado",
    invite_friends: "Invitar amigos",
    friends_income_desc: "+2% de ingresos del amigo en exposiciones",
    repair_free: "Gratis",
    no_influence_paintings: "Aun no hay pinturas con influencia. Empieza a exponer!",
    today_bonus: "Bono de hoy",
    next_bonus: "Proximo bono",
    friends_invited: "Amigos invitados", income_from_friends: "Ingresos de amigos",
    daily_bonus: "Bonus diario", consecutive_days: "Dias consecutivos",
    next_bonus: "Proximo bonus", claim_bonus: "Cobrar bonus",
    complete_all: "Completa todas las tareas diarias", all_tasks: "Bonus por todas las tareas",
    discover: "Descubrir", achievements: "Logros",
    collect_5_artist: "Colecciona 5 pinturas del mismo artista",
    collect_5_year: "Colecciona 5 pinturas del mismo ano",
    same_artist: "Mismo artista", same_year: "Mismo ano",
    claim_rewards: "Cobrar recompensas",
    subscribe_channel: "Suscribirse al canal",
    subscribe_desc: "Suscribete a @privateart y gana monedas",
    subscribe_btn: "Suscribirse",
    boost_channel: "Boost del canal", boost_desc: "Haz boost a @privateart",
    boost_btn: "Boost", per_boost: "por boost",
    gift_channel: "Regalo al canal",
    gift_desc: "Envia un regalo a @privateart y gana monedas",
    gift_btn: "Regalar",
    one_time: "una vez",
    discover_3_ref: "Invita a 3 amigos", discover_5: "Descubre 5 pinturas",
    max_level: "MAX",
    delete_account: "Eliminar cuenta",
    delete_confirm: "Eliminar cuenta? Todos los datos se perderan permanentemente!",
    total_rating: "Rating total", your_rank: "Tu posicion",
    auction_desc: "Aqui podras vender tus pinturas a otros jugadores por Telegram Stars. La subasta se abrira cuando existan 10 pinturas Masterpiece en el juego.",
    masterpiece_count: "Pinturas Masterpiece en el juego",
    leaderboard: "Clasificacion",
    total_influence: "Influencia total de pinturas",
    welcome: "Bienvenido!", first_painting: "Tu primera pintura te espera",
    tap_to_reveal: "Toca para revelar", skip_onboard: "Saltar", continue_btn: "Continuar",
    loading: "Cargando...", error: "Error", retry: "Reintentar",
    stars_payment: "Pago con Telegram Stars",
    collect_painting: "Recoger pintura",
    add_to_collection: "Agregar a coleccion", new_card: "Nueva pintura!",
    no_cards: "Aun no hay pinturas", buy: "Comprar", cards: "Pinturas",
    language: "Idioma", owner: "Propietario",
    same_artist_5: "Mismo artista x5", same_year_5: "Mismo ano x5",
    your_coins: "Tus monedas", painting_slots: "Espacios de pinturas",
    slots_full: "Todos los espacios llenos. Mejora los espacios",
    supply_tooltip: "Cuantas de esta pintura con este nivel existen",
    rarity_thresholds: "Umbrales de nivel",
    condition_tooltip: "El estado se deteriora con el tiempo. Repara la pintura para restaurarla",
    max_rarity: "Nivel maximo alcanzado!",
    sell: "Vender", sell_masterpiece_only: "Solo se pueden vender pinturas Masterpiece",
    collect: "Recoger",
    platinum: "Platino", gold: "Oro", bronze: "Bronce",
    year: "Ano", rating: "Rating",
    hours_short: "h",
    tut_details: "Averigüemos que tipo de pintura es. Algunas pinturas pueden valer mucho!",
    tut_repair: "Presiona para reparar",
    tut_exhibit: "Toca para empezar a ganar monedas",
    tut_exhibit_pick: "Mientras tu pintura esta en exhibicion, gana influencia e ingresos. La influencia aumenta el nivel de la pintura, generando mayores recompensas.",
    tut_buy: "Ahora compremos otra pintura — nunca sabes lo que obtendras. Buena suerte!",
    level_upgraded: "Nivel de pintura mejorado",
    view_post: "Ver original", coming_soon_text: "Proximamente...",
  },
  ar: {
    bulk_all: "الكل",
    bulk_exhibit_label: "عرض", bulk_repair_label: "ترميم",
    bulk_repairing: "جارٍ الترميم",
    bulk_exhibiting: "جارٍ العرض",
    bulk_repaired: "تم ترميم {n} لوحة (−{spent} عملة)",
    bulk_exhibited: "يتم عرض {n} لوحة",
    bulk_skipped: "تم تخطي {n} لوحة — العملات غير كافية",
    bulk_no_coins: "العملات غير كافية للترميم",
    bulk_slots_full: "كل خانات العرض مشغولة",
    coll_loading: "جارٍ التحميل…",
    coll_new: "مجموعة جديدة",
    coll_name_placeholder: "اسم المجموعة",
    coll_create: "إنشاء",
    coll_creating: "جارٍ الإنشاء…",
    coll_cancel: "إلغاء",
    coll_need_coins: "التكلفة {cost} عملة — ينقصك {n}",
    coll_coins_short: "ينقصك {n} عملة",
    coll_created: "تم إنشاء المجموعة «{name}»",
    coll_deleted: "تم حذف المجموعة «{name}»",
    coll_create_failed: "تعذّر الإنشاء",
    coll_empty_hint: "المجموعات تعرض لوحاتك. تبقى في معرضك وتواصل تحقيق الدخل.",
    buff_load_failed: "تعذّر تحميل المكافأة. اقلب البطاقة مرة أخرى.",
    rarity_common: "عادية",
    rarity_uncommon: "غير شائعة",
    rarity_rare: "نادرة",
    rarity_legendary: "أسطورية",
    rarity_masterpiece: "تحفة",
    buff_title: "مكافآت المجموعة",
    buff_in_collection: "في المجموعة",
    buff_total: "إجمالي المكافأة",
    buff_applies: "يزيد عملات المعرض ونقاط التأثير",
    buff_per_hour: "عملة/ساعة بالحالة الراهنة",
    buff_no_collection: "ليست ضمن مجموعة",
    buff_no_collection_hint: "ضع اللوحة في مجموعة — اللوحات التي تشترك في الفنان أو السنة أو الندرة أو حالة Unique / TON تعزز بعضها.",
    buff_no_sets: "لا توجد مكافآت بعد",
    buff_no_sets_hint: "أضف لوحة لنفس الفنان أو من نفس السنة لتبدأ المكافأة.",
    buff_rules: "نفس الفنان أو السنة: من لوحتين. نفس الندرة: من 5. Unique ‎+5%‎ لكل لوحة، TON ‎+1%‎. كل المكافآت تتراكم.",
    set_artist: "الفنان",
    set_year: "السنة",
    set_rarity: "الندرة",
    set_unique: "Unique",
    set_ton: "TON",
    collection: "المجموعة", gallery: "المعرض", earn: "اكسب", upgrades: "التطويرات", top: "Top", auction: "المزاد", profile: "الملف الشخصي",
    balance: "الرصيد",
    no_paintings_yet: "لا توجد لوحات بعد",
    buy_random_desc: "اشتر لوحة عشوائية او ادع اصدقاء لبدء مجموعتك!",
    buy_random: "شراء لوحة", buy_random_card: "شراء لوحة",
    reel_roll_for: "تدوير مقابل",
    reel_purchase_failed: "فشل الشراء",
    reel_loading: "جار التحميل…",
    reel_unavailable: "لا توجد لوحات متاحة",
    reel_you_got: "حصلت على: {title}",
    reel_continue: "متابعة",
    reel_spinning: "جار التدوير…",
    reel_need_more: "تحتاج {n} عملة اضافية",
    reel_free_painting: "لوحة مجانية",
    exhibit: "عرض", repair: "اصلاح", details: "التفاصيل", burn: "حرق",
    exhibited: "معروضة", collect_reward: "جمع المكافاة",
    choose_duration: "اختر مدة العرض",
    cancel: "الغاء",
    all_slots_busy: "جميع الخانات ممتلئة. قم بالترقية لعرض المزيد.",
    card_destroyed: "اللوحة دمرت (0% حالة)",
    not_enough_coins: "عملات غير كافية",
    free: "مجاني",
    adding: "جاري الاضافة...", added: "تمت الاضافة!",
    rarity: "المستوى", condition: "الحالة", supply: "الاصدار", influence: "التاثير",
    open_post: "فتح المنشور", buff: "تعزيز", coming_soon: "قريبا!",
    swipe_hint: "اسحب لاستكشاف المعرض", tap_hint: "انقر على اللوحة",
    exhibited_in_paris: "معروضة في باريس", exhibited_in_new_york: "معروضة في نيويورك",
    exhibited_in_london: "معروضة في لندن", exhibited_in_rome: "معروضة في روما",
    exhibited_in_berlin: "معروضة في برلين", exhibited_in_tokyo: "معروضة في طوكيو",
    exhibited_in_madrid: "معروضة في مدريد", exhibited_in_vienna: "معروضة في فيينا",
    exhibited_in_amsterdam: "معروضة في امستردام", exhibited_in_budapest: "معروضة في بودابست",
    exhibited_in_dubai: "معروضة في دبي", exhibited_in_florence: "معروضة في فلورنسا",
    exhibited_in_los_angeles: "معروضة في لوس انجلوس", exhibited_in_prague: "معروضة في براغ",
    exhibited_in_milan: "معروضة في ميلان", exhibited_in_barcelona: "معروضة في برشلونة",
    exhibited_in_zurich: "معروضة في زيورخ", exhibited_in_seoul: "معروضة في سيول",
    exhibited_in_istanbul: "معروضة في اسطنبول", exhibited_in_copenhagen: "معروضة في كوبنهاغن",
    exhibited_in_singapore: "معروضة في سنغافورة",
    discover_art: "اكتشف Private Art", daily_tasks: "المهام اليومية",
    refresh_in: "تحديث خلال", skip: "تخطي",
    coins: "عملات", today: "اليوم", per_friend: "لكل صديق",
    claim: "استلام", claimed: "تم الاستلام",
    invite_friends: "دعوة اصدقاء",
    friends_income_desc: "+2% من دخل الصديق من المعارض",
    repair_free: "مجاني",
    no_influence_paintings: "لا توجد لوحات ذات تاثير بعد. ابدا العرض!",
    today_bonus: "مكافاة اليوم",
    next_bonus: "المكافاة التالية",
    friends_invited: "اصدقاء مدعوون", income_from_friends: "دخل من الاصدقاء",
    daily_bonus: "المكافاة اليومية", consecutive_days: "ايام متتالية",
    next_bonus: "المكافاة التالية", claim_bonus: "استلام المكافاة",
    complete_all: "اكمل جميع المهام اليومية", all_tasks: "مكافاة جميع المهام",
    discover: "اكتشف", achievements: "الانجازات",
    collect_5_artist: "اجمع 5 لوحات لنفس الفنان",
    collect_5_year: "اجمع 5 لوحات من نفس العام",
    same_artist: "نفس الفنان", same_year: "نفس العام",
    claim_rewards: "استلام المكافات",
    subscribe_channel: "اشترك في القناة",
    subscribe_desc: "اشترك في @privateart واكسب عملات",
    subscribe_btn: "اشتراك",
    boost_channel: "تعزيز القناة", boost_desc: "عزز قناة @privateart",
    boost_btn: "تعزيز", per_boost: "لكل تعزيز",
    gift_channel: "هدية للقناة",
    gift_desc: "ارسل هدية لـ @privateart واكسب عملات",
    gift_btn: "ارسال هدية",
    one_time: "مرة واحدة",
    discover_3_ref: "ادع 3 اصدقاء", discover_5: "اكتشف 5 لوحات",
    max_level: "الحد الاقصى",
    delete_account: "حذف الحساب",
    delete_confirm: "حذف الحساب؟ ستفقد جميع البيانات نهائيا!",
    total_rating: "التقييم الاجمالي", your_rank: "ترتيبك",
    auction_desc: "هنا يمكنك بيع لوحاتك للاعبين اخرين مقابل Telegram Stars. سيفتح المزاد عند وجود 10 لوحات Masterpiece في اللعبة.",
    masterpiece_count: "لوحات Masterpiece في اللعبة",
    leaderboard: "لوحة الصدارة",
    total_influence: "اجمالي تاثير اللوحات",
    welcome: "اهلا وسهلا!", first_painting: "لوحتك الاولى بانتظارك",
    tap_to_reveal: "انقر للكشف", skip_onboard: "تخطي", continue_btn: "متابعة",
    loading: "جاري التحميل...", error: "خطا", retry: "اعادة المحاولة",
    stars_payment: "الدفع عبر Telegram Stars",
    collect_painting: "جمع اللوحة",
    add_to_collection: "اضافة للمجموعة", new_card: "لوحة جديدة!",
    no_cards: "لا توجد لوحات بعد", buy: "شراء", cards: "اللوحات",
    language: "اللغة", owner: "المالك",
    same_artist_5: "نفس الفنان x5", same_year_5: "نفس العام x5",
    your_coins: "عملاتك", painting_slots: "خانات اللوحات",
    slots_full: "جميع الخانات ممتلئة. قم بترقية الخانات",
    supply_tooltip: "كم عدد هذه اللوحة بهذا المستوى في اللعبة",
    rarity_thresholds: "حدود المستويات",
    condition_tooltip: "الحالة تتدهور مع الوقت. قم باصلاح اللوحة لاستعادتها",
    max_rarity: "تم بلوغ اقصى مستوى!",
    sell: "بيع", sell_masterpiece_only: "يمكن بيع لوحات Masterpiece فقط",
    collect: "جمع",
    platinum: "بلاتين", gold: "ذهب", bronze: "برونز",
    year: "السنة", rating: "التقييم",
    hours_short: "س",
    tut_details: "لنكتشف ما نوع هذه اللوحة. بعض اللوحات قد تكون ذات قيمة عالية!",
    tut_repair: "اضغط للإصلاح",
    tut_exhibit: "اضغط لتبدا في كسب العملات",
    tut_exhibit_pick: "اثناء عرض لوحتك تكتسب تاثيرا ودخلا. التاثير يرفع مستوى اللوحة مما يولد مكافات اعلى.",
    tut_buy: "الان لنشتري لوحة اخرى — لا تعرف ماذا ستحصل. حظا سعيدا!",
    level_upgraded: "تمت ترقية مستوى اللوحة",
    view_post: "عرض الأصلي", coming_soon_text: "قريبا...",
  },
  uk: {
    bulk_all: "Усі",
    bulk_exhibit_label: "Виставити", bulk_repair_label: "Полагодити",
    bulk_repairing: "Ремонтуємо",
    bulk_exhibiting: "Виставляємо",
    bulk_repaired: "Відремонтовано картин: {n} (−{spent} монет)",
    bulk_exhibited: "Виставлено картин: {n}",
    bulk_skipped: "Пропущено картин: {n} — не вистачило монет",
    bulk_no_coins: "Не вистачає монет на ремонт",
    bulk_slots_full: "Усі слоти виставки зайняті",
    coll_loading: "Завантаження…",
    coll_new: "Нова колекція",
    coll_name_placeholder: "Назва колекції",
    coll_create: "Створити",
    coll_creating: "Створюємо…",
    coll_cancel: "Скасувати",
    coll_need_coins: "Потрібно {cost} монет — не вистачає {n}",
    coll_coins_short: "Не вистачає {n} монет",
    coll_created: "Колекцію «{name}» створено",
    coll_deleted: "Колекцію «{name}» видалено",
    coll_create_failed: "Не вдалося створити",
    coll_empty_hint: "Колекції — вітрина твоїх картин. Картини лишаються в галереї та продовжують приносити дохід.",
    buff_load_failed: "Не вдалося завантажити бонус. Переверніть картку ще раз.",
    rarity_common: "Звичайна",
    rarity_uncommon: "Незвичайна",
    rarity_rare: "Рідкісна",
    rarity_legendary: "Легендарна",
    rarity_masterpiece: "Шедевр",
    buff_title: "Бонуси колекції",
    buff_in_collection: "У колекції",
    buff_total: "Загальний бонус",
    buff_applies: "Збільшує монети з виставки та influence XP",
    buff_per_hour: "монет/год за поточного стану",
    buff_no_collection: "Не в колекції",
    buff_no_collection_hint: "Додайте картину до колекції — картини зі спільним художником, роком, рідкістю або статусом Unique / TON підсилюють одна одну.",
    buff_no_sets: "Бонусів поки немає",
    buff_no_sets_hint: "Додайте картину того самого художника або того самого року, щоб бонус запрацював.",
    buff_rules: "Один художник або рік — від 2 картин. Одна рідкість — від 5. Unique +5% за картину, TON +1%. Усі бонуси додаються.",
    set_artist: "Художник",
    set_year: "Рік",
    set_rarity: "Рідкість",
    set_unique: "Unique",
    set_ton: "TON",
    collection: "Коллекція", gallery: "Галерея", earn: "Заробити", upgrades: "Покращення", top: "Топ", auction: "Аукцiон", profile: "Профiль",
    balance: "Баланс",
    no_paintings_yet: "Поки немае картин",
    buy_random_desc: "Придбайте випадкову картину або запросiть друзiв щоб розпочати колекцiю!",
    buy_random: "Купити картину", buy_random_card: "Купити картину",
    reel_roll_for: "Крутити за",
    reel_purchase_failed: "Покупка не вдалася",
    reel_loading: "Завантаження…",
    reel_unavailable: "Картини недоступнi",
    reel_you_got: "Ви отримали: {title}",
    reel_continue: "Забрати",
    reel_spinning: "Крутимо…",
    reel_need_more: "Потрiбно ще {n} монет",
    reel_free_painting: "Безкоштовна картина",
    exhibit: "Виставити", repair: "Полагодити", details: "Деталi", burn: "Спалити",
    exhibited: "На виставцi", collect_reward: "Забрати нагороду",
    choose_duration: "Оберiть тривалiсть виставки",
    cancel: "Скасувати",
    all_slots_busy: "Всi слоти зайнятi. Покращiть щоб виставляти бiльше.",
    card_destroyed: "Картину знищено (0% стану)",
    not_enough_coins: "Недостатньо монет",
    free: "Безкоштовно",
    adding: "Додаемо...", added: "Додано!",
    rarity: "Рiвень", condition: "Стан", supply: "Тираж", influence: "Вплив",
    open_post: "Вiдкрити пост", buff: "Бафф", coming_soon: "Незабаром!",
    swipe_hint: "Свайпнiть щоб дослiдити галерею", tap_hint: "Натиснiть на картину",
    exhibited_in_paris: "Виставка в Парижi", exhibited_in_new_york: "Виставка в Нью-Йорку",
    exhibited_in_london: "Виставка в Лондонi", exhibited_in_rome: "Виставка в Римi",
    exhibited_in_berlin: "Виставка в Берлiнi", exhibited_in_tokyo: "Виставка в Токiо",
    exhibited_in_madrid: "Виставка в Мадридi", exhibited_in_vienna: "Виставка у Вiднi",
    exhibited_in_amsterdam: "Виставка в Амстердамi", exhibited_in_budapest: "Виставка в Будапештi",
    exhibited_in_dubai: "Виставка в Дубаi", exhibited_in_florence: "Виставка у Флоренцii",
    exhibited_in_los_angeles: "Виставка в Лос-Анджелесi", exhibited_in_prague: "Виставка в Празi",
    exhibited_in_milan: "Виставка в Мiланi", exhibited_in_barcelona: "Виставка в Барселонi",
    exhibited_in_zurich: "Виставка в Цюрiху", exhibited_in_seoul: "Виставка в Сеулi",
    exhibited_in_istanbul: "Виставка в Стамбулi", exhibited_in_copenhagen: "Виставка в Копенгагенi",
    exhibited_in_singapore: "Виставка в Сiнгапурi",
    discover_art: "Вiдкрий Private Art", daily_tasks: "Щоденнi завдання",
    refresh_in: "Оновлення через", skip: "Пропустити",
    coins: "монет", today: "сьогоднi", per_friend: "за друга",
    claim: "Забрати", claimed: "Отримано",
    invite_friends: "Запросити друзiв",
    friends_income_desc: "+2% вiд доходу друга з виставок",
    repair_free: "Безкоштовно",
    no_influence_paintings: "Поки немае картин з впливом. Починайте виставляти!",
    today_bonus: "Сьогоднiшнiй бонус",
    next_bonus: "Наступний бонус",
    friends_invited: "Друзiв запрошено", income_from_friends: "Дохiд вiд друзiв",
    daily_bonus: "Щоденний бонус", consecutive_days: "Днiв поспiль",
    next_bonus: "Наступний бонус", claim_bonus: "Отримати бонус",
    complete_all: "Виконайте всi щоденнi завдання", all_tasks: "Бонус за всi завдання",
    discover: "Вiдкрити", achievements: "Досягнення",
    collect_5_artist: "Зiбрати 5 картин одного художника",
    collect_5_year: "Зiбрати 5 картин одного року",
    same_artist: "Один художник", same_year: "Один рiк",
    claim_rewards: "Забрати нагороди",
    subscribe_channel: "Пiдписка на канал",
    subscribe_desc: "Пiдпишiться на @privateart та отримайте монети",
    subscribe_btn: "Пiдписатись",
    boost_channel: "Буст каналу", boost_desc: "Бустнiть канал @privateart",
    boost_btn: "Бустнути", per_boost: "за буст",
    gift_channel: "Подарунок каналу",
    gift_desc: "Подаруйте гiфт каналу @privateart",
    gift_btn: "Подарувати",
    one_time: "одноразово",
    discover_3_ref: "Запросити 3 друзiв", discover_5: "Вiдкрити 5 картин",
    max_level: "МАКС",
    delete_account: "Видалити акаунт",
    delete_confirm: "Видалити акаунт? Всi данi буде втрачено назавжди!",
    total_rating: "Загальний рейтинг", your_rank: "Ваше мiсце",
    auction_desc: "Тут ви зможете продавати свoi картини iншим гравцям за Telegram Stars. Аукцiон вiдкриеться коли в грi з'явиться 10 картин зi статусом Masterpiece.",
    masterpiece_count: "Картин Masterpiece в грi",
    leaderboard: "Рейтинг",
    total_influence: "Сумарний вплив картин",
    welcome: "Ласкаво просимо!", first_painting: "Ваша перша картина чекае",
    tap_to_reveal: "Натиснiть щоб вiдкрити", skip_onboard: "Пропустити", continue_btn: "Продовжити",
    loading: "Завантаження...", error: "Помилка", retry: "Повторити",
    stars_payment: "Оплата через Telegram Stars",
    collect_painting: "Забрати картину",
    add_to_collection: "Додати до колекцii", new_card: "Нова картина!",
    no_cards: "Поки немае картин", buy: "Купити", cards: "Картини",
    language: "Мова", owner: "Власник",
    same_artist_5: "Один художник x5", same_year_5: "Один рiк x5",
    your_coins: "Вашi монети", painting_slots: "Слоти для картин",
    slots_full: "Всi слоти зайнятi. Покращiть слоти",
    supply_tooltip: "Скiльки таких картин цього рiвня в грi",
    rarity_thresholds: "Пороги рiвнiв",
    condition_tooltip: "Стан погiршуеться з часом. Полагодiть картину щоб вiдновити",
    max_rarity: "Максимальний рiвень!",
    sell: "Продати", sell_masterpiece_only: "Тiльки картини Masterpiece можна продавати",
    collect: "Забрати",
    platinum: "Платина", gold: "Золото", bronze: "Бронза",
    year: "Рiк", rating: "Рейтинг",
    hours_short: "г",
    tut_details: "Давайте дiзнаемось що за картина перед нами. Деякi картини можуть коштувати цiле багатство!",
    tut_repair: "Натисни, щоб полагодити",
    tut_exhibit: "Натисни, щоб почати заробляти монети",
    tut_exhibit_pick: "Поки картина на виставцi, вона набирае вплив та дохiд. Вплив пiдвищуе рiвень картини, що приносить бiльше нагород.",
    tut_buy: "Тепер давайте купимо ще одну картину — нiколи не знаеш що трапиться. Удачi!",
    level_upgraded: "Картина пiдвищила рiвень",
    exhibited: "На виставцi", collect_reward: "Забрати нагороду",
    details: "Деталi", buff: "Бафф", coming_soon_text: "Скоро...",
    view_post: "Вiдкрити оригiнал", repair: "Полагодити",
  },
  fr: {
    bulk_all: "Tous",
    bulk_exhibit_label: "Exposer", bulk_repair_label: "Restaurer",
    bulk_repairing: "Restauration",
    bulk_exhibiting: "Exposition",
    bulk_repaired: "{n} tableaux restaurés (−{spent} pièces)",
    bulk_exhibited: "{n} tableaux exposés",
    bulk_skipped: "{n} tableaux ignorés — pièces insuffisantes",
    bulk_no_coins: "Pas assez de pièces pour restaurer",
    bulk_slots_full: "Tous les emplacements d'exposition sont occupés",
    coll_loading: "Chargement…",
    coll_new: "Nouvelle collection",
    coll_name_placeholder: "Nom de la collection",
    coll_create: "Créer",
    coll_creating: "Création…",
    coll_cancel: "Annuler",
    coll_need_coins: "Coûte {cost} pièces — il vous manque {n}",
    coll_coins_short: "Il vous manque {n} pièces",
    coll_created: "Collection « {name} » créée",
    coll_deleted: "Collection « {name} » supprimée",
    coll_create_failed: "Création impossible",
    coll_empty_hint: "Les collections mettent vos tableaux en vitrine. Ils restent dans votre galerie et continuent de rapporter.",
    buff_load_failed: "Impossible de charger le bonus. Retournez la carte à nouveau.",
    rarity_common: "Commune",
    rarity_uncommon: "Peu commune",
    rarity_rare: "Rare",
    rarity_legendary: "Légendaire",
    rarity_masterpiece: "Chef-d’œuvre",
    buff_title: "Bonus de collection",
    buff_in_collection: "Dans la collection",
    buff_total: "Bonus total",
    buff_applies: "Augmente les pièces d'exposition et l'influence XP",
    buff_per_hour: "pièces/h à l'état actuel",
    buff_no_collection: "Hors collection",
    buff_no_collection_hint: "Placez ce tableau dans une collection : les œuvres partageant un artiste, une année, une rareté ou le statut Unique / TON se renforcent entre elles.",
    buff_no_sets: "Pas encore de bonus",
    buff_no_sets_hint: "Ajoutez un tableau du même artiste ou de la même année pour activer le bonus.",
    buff_rules: "Même artiste ou année : dès 2 tableaux. Même rareté : dès 5. Unique +5% chacun, TON +1%. Tous les bonus se cumulent.",
    set_artist: "Artiste",
    set_year: "Année",
    set_rarity: "Rareté",
    set_unique: "Unique",
    set_ton: "TON",
    collection: "Collection", gallery: "Galerie", earn: "Gagner", upgrades: "Ameliorations", top: "Top", auction: "Encheres", profile: "Profil",
    balance: "Solde",
    no_paintings_yet: "Pas encore de peintures",
    buy_random_desc: "Achetez une peinture aleatoire ou invitez des amis pour commencer votre collection!",
    buy_random: "Acheter une peinture", buy_random_card: "Acheter une peinture",
    reel_roll_for: "Tourner pour",
    reel_purchase_failed: "Achat echoue",
    reel_loading: "Chargement…",
    reel_unavailable: "Aucune peinture disponible",
    reel_you_got: "Vous avez obtenu: {title}",
    reel_continue: "Continuer",
    reel_spinning: "Rotation…",
    reel_need_more: "Il te faut {n} pieces de plus",
    reel_free_painting: "Peinture gratuite",
    exhibit: "Exposer", repair: "Reparer", details: "Details", burn: "Bruler",
    exhibited: "En exposition", collect_reward: "Recuperer la recompense",
    choose_duration: "Choisissez la duree d'exposition",
    cancel: "Annuler",
    all_slots_busy: "Tous les emplacements occupes. Ameliorez pour exposer plus.",
    card_destroyed: "Peinture detruite (0% etat)",
    not_enough_coins: "Pieces insuffisantes",
    free: "Gratuit",
    adding: "Ajout...", added: "Ajoute!",
    rarity: "Niveau", condition: "Etat", supply: "Tirage", influence: "Influence",
    open_post: "Ouvrir le post", buff: "Buff", coming_soon: "Bientot!",
    swipe_hint: "Glissez pour explorer la galerie", tap_hint: "Appuyez sur la peinture",
    exhibited_in_paris: "Exposee a Paris", exhibited_in_new_york: "Exposee a New York",
    exhibited_in_london: "Exposee a Londres", exhibited_in_rome: "Exposee a Rome",
    exhibited_in_berlin: "Exposee a Berlin", exhibited_in_tokyo: "Exposee a Tokyo",
    exhibited_in_madrid: "Exposee a Madrid", exhibited_in_vienna: "Exposee a Vienne",
    exhibited_in_amsterdam: "Exposee a Amsterdam", exhibited_in_budapest: "Exposee a Budapest",
    exhibited_in_dubai: "Exposee a Dubai", exhibited_in_florence: "Exposee a Florence",
    exhibited_in_los_angeles: "Exposee a Los Angeles", exhibited_in_prague: "Exposee a Prague",
    exhibited_in_milan: "Exposee a Milan", exhibited_in_barcelona: "Exposee a Barcelone",
    exhibited_in_zurich: "Exposee a Zurich", exhibited_in_seoul: "Exposee a Seoul",
    exhibited_in_istanbul: "Exposee a Istanbul", exhibited_in_copenhagen: "Exposee a Copenhague",
    exhibited_in_singapore: "Exposee a Singapour",
    discover_art: "Decouvrez Private Art", daily_tasks: "Taches quotidiennes",
    refresh_in: "Actualisation dans", skip: "Passer",
    coins: "pieces", today: "aujourd'hui", per_friend: "par ami",
    claim: "Recuperer", claimed: "Recupere",
    invite_friends: "Inviter des amis",
    friends_income_desc: "+2% des revenus d'exposition de l'ami",
    repair_free: "Gratuit",
    no_influence_paintings: "Aucune peinture avec influence. Commencez a exposer!",
    today_bonus: "Bonus du jour",
    next_bonus: "Prochain bonus",
    friends_invited: "Amis invites", income_from_friends: "Revenus des amis",
    daily_bonus: "Bonus quotidien", consecutive_days: "Jours consecutifs",
    next_bonus: "Prochain bonus", claim_bonus: "Recuperer le bonus",
    complete_all: "Completez toutes les taches quotidiennes", all_tasks: "Bonus toutes taches",
    discover: "Decouvrir", achievements: "Succes",
    collect_5_artist: "Collectionnez 5 peintures du meme artiste",
    collect_5_year: "Collectionnez 5 peintures de la meme annee",
    same_artist: "Meme artiste", same_year: "Meme annee",
    claim_rewards: "Recuperer les recompenses",
    subscribe_channel: "S'abonner au canal",
    subscribe_desc: "Abonnez-vous a @privateart et gagnez des pieces",
    subscribe_btn: "S'abonner",
    boost_channel: "Booster le canal", boost_desc: "Boostez le canal @privateart",
    boost_btn: "Booster", per_boost: "par boost",
    gift_channel: "Cadeau au canal",
    gift_desc: "Envoyez un cadeau a @privateart et gagnez des pieces",
    gift_btn: "Offrir",
    one_time: "unique",
    discover_3_ref: "Invitez 3 amis", discover_5: "Decouvrez 5 peintures",
    max_level: "MAX",
    delete_account: "Supprimer le compte",
    delete_confirm: "Supprimer le compte? Toutes les donnees seront perdues definitivement!",
    total_rating: "Note totale", your_rank: "Votre classement",
    auction_desc: "Ici vous pourrez vendre vos peintures a d'autres joueurs pour des Telegram Stars. Les encheres s'ouvriront quand 10 peintures Masterpiece existeront dans le jeu.",
    masterpiece_count: "Peintures Masterpiece dans le jeu",
    leaderboard: "Classement",
    total_influence: "Influence totale des peintures",
    welcome: "Bienvenue!", first_painting: "Votre premiere peinture vous attend",
    tap_to_reveal: "Appuyez pour reveler", skip_onboard: "Passer", continue_btn: "Continuer",
    loading: "Chargement...", error: "Erreur", retry: "Reessayer",
    stars_payment: "Paiement via Telegram Stars",
    collect_painting: "Recuperer la peinture",
    add_to_collection: "Ajouter a la collection", new_card: "Nouvelle peinture!",
    no_cards: "Pas encore de peintures", buy: "Acheter", cards: "Peintures",
    language: "Langue", owner: "Proprietaire",
    same_artist_5: "Meme artiste x5", same_year_5: "Meme annee x5",
    your_coins: "Vos pieces", painting_slots: "Emplacements de peintures",
    slots_full: "Tous les emplacements pleins. Ameliorez les emplacements",
    supply_tooltip: "Combien de cette peinture a ce niveau existent",
    rarity_thresholds: "Seuils de niveau",
    condition_tooltip: "L'etat se degrade avec le temps. Reparez la peinture pour la restaurer",
    max_rarity: "Niveau maximal atteint!",
    sell: "Vendre", sell_masterpiece_only: "Seules les peintures Masterpiece peuvent etre vendues",
    collect: "Recuperer",
    platinum: "Platine", gold: "Or", bronze: "Bronze",
    year: "Annee", rating: "Note",
    hours_short: "h",
    tut_details: "Decouvrons quel type de peinture c'est. Certaines peintures peuvent valoir beaucoup!",
    tut_repair: "Appuyez pour reparer",
    tut_exhibit: "Appuie pour commencer a gagner des pieces",
    tut_exhibit_pick: "Pendant que votre peinture est exposee, elle gagne de l'influence et des revenus. L'influence augmente le niveau de la peinture, generant des recompenses plus elevees.",
    tut_buy: "Maintenant achetons une autre peinture — on ne sait jamais ce qu'on obtient. Bonne chance!",
    level_upgraded: "Niveau de peinture ameliore",
    view_post: "Voir l'original", coming_soon_text: "Bientot...",
  },
  pt: {
    bulk_all: "Todas",
    bulk_exhibit_label: "Exibir", bulk_repair_label: "Restaurar",
    bulk_repairing: "Restaurando",
    bulk_exhibiting: "Exibindo",
    bulk_repaired: "{n} pinturas restauradas (−{spent} moedas)",
    bulk_exhibited: "Exibindo {n} pinturas",
    bulk_skipped: "{n} pinturas ignoradas — moedas insuficientes",
    bulk_no_coins: "Moedas insuficientes para restaurar",
    bulk_slots_full: "Todos os espaços de exibição estão ocupados",
    coll_loading: "Carregando…",
    coll_new: "Nova coleção",
    coll_name_placeholder: "Nome da coleção",
    coll_create: "Criar",
    coll_creating: "Criando…",
    coll_cancel: "Cancelar",
    coll_need_coins: "Custa {cost} moedas — faltam {n}",
    coll_coins_short: "Faltam {n} moedas",
    coll_created: "Coleção «{name}» criada",
    coll_deleted: "Coleção «{name}» excluída",
    coll_create_failed: "Não foi possível criar",
    coll_empty_hint: "As coleções exibem suas pinturas. Elas continuam na galeria e continuam rendendo.",
    buff_load_failed: "Não foi possível carregar o bônus. Vire a carta novamente.",
    rarity_common: "Comum",
    rarity_uncommon: "Incomum",
    rarity_rare: "Rara",
    rarity_legendary: "Lendária",
    rarity_masterpiece: "Obra-prima",
    buff_title: "Bônus da coleção",
    buff_in_collection: "Na coleção",
    buff_total: "Bônus total",
    buff_applies: "Aumenta as moedas da exibição e a influência XP",
    buff_per_hour: "moedas/h na condição atual",
    buff_no_collection: "Fora de coleção",
    buff_no_collection_hint: "Coloque esta pintura em uma coleção: obras que compartilham artista, ano, raridade ou status Unique / TON se reforçam.",
    buff_no_sets: "Ainda sem bônus",
    buff_no_sets_hint: "Adicione uma pintura do mesmo artista ou do mesmo ano para começar a ganhar.",
    buff_rules: "Mesmo artista ou ano: a partir de 2 pinturas. Mesma raridade: a partir de 5. Unique +5% cada, TON +1%. Todos os bônus somam.",
    set_artist: "Artista",
    set_year: "Ano",
    set_rarity: "Raridade",
    set_unique: "Unique",
    set_ton: "TON",
    collection: "Colecao", gallery: "Galeria", earn: "Ganhar", upgrades: "Melhorias", top: "Top", auction: "Leilao", profile: "Perfil",
    balance: "Saldo",
    no_paintings_yet: "Ainda sem pinturas",
    buy_random_desc: "Compre uma pintura aleatoria ou convide amigos para comecar sua colecao!",
    buy_random: "Comprar pintura", buy_random_card: "Comprar pintura",
    reel_roll_for: "Girar por",
    reel_purchase_failed: "Compra falhou",
    reel_loading: "Carregando…",
    reel_unavailable: "Nenhuma pintura disponivel",
    reel_you_got: "Voce recebeu: {title}",
    reel_continue: "Continuar",
    reel_spinning: "Girando…",
    reel_need_more: "Precisa de {n} moedas a mais",
    reel_free_painting: "Pintura gratis",
    exhibit: "Exibir", repair: "Reparar", details: "Detalhes", burn: "Queimar",
    exhibited: "Em exposicao", collect_reward: "Coletar recompensa",
    choose_duration: "Escolha a duracao da exposicao",
    cancel: "Cancelar",
    all_slots_busy: "Todos os espacos ocupados. Melhore para exibir mais.",
    card_destroyed: "Pintura destruida (0% condicao)",
    not_enough_coins: "Moedas insuficientes",
    free: "Gratis",
    adding: "Adicionando...", added: "Adicionado!",
    rarity: "Nivel", condition: "Condicao", supply: "Tiragem", influence: "Influencia",
    open_post: "Abrir post", buff: "Buff", coming_soon: "Em breve!",
    swipe_hint: "Deslize para explorar a galeria", tap_hint: "Toque na pintura",
    exhibited_in_paris: "Exposta em Paris", exhibited_in_new_york: "Exposta em Nova York",
    exhibited_in_london: "Exposta em Londres", exhibited_in_rome: "Exposta em Roma",
    exhibited_in_berlin: "Exposta em Berlim", exhibited_in_tokyo: "Exposta em Toquio",
    exhibited_in_madrid: "Exposta em Madri", exhibited_in_vienna: "Exposta em Viena",
    exhibited_in_amsterdam: "Exposta em Amsterda", exhibited_in_budapest: "Exposta em Budapeste",
    exhibited_in_dubai: "Exposta em Dubai", exhibited_in_florence: "Exposta em Florenca",
    exhibited_in_los_angeles: "Exposta em Los Angeles", exhibited_in_prague: "Exposta em Praga",
    exhibited_in_milan: "Exposta em Milao", exhibited_in_barcelona: "Exposta em Barcelona",
    exhibited_in_zurich: "Exposta em Zurique", exhibited_in_seoul: "Exposta em Seul",
    exhibited_in_istanbul: "Exposta em Istambul", exhibited_in_copenhagen: "Exposta em Copenhague",
    exhibited_in_singapore: "Exposta em Singapura",
    discover_art: "Descubra Private Art", daily_tasks: "Tarefas diarias",
    refresh_in: "Atualiza em", skip: "Pular",
    coins: "moedas", today: "hoje", per_friend: "por amigo",
    claim: "Coletar", claimed: "Coletado",
    invite_friends: "Convidar amigos",
    friends_income_desc: "+2% da renda do amigo em exposicoes",
    repair_free: "Gratis",
    no_influence_paintings: "Ainda sem pinturas com influencia. Comece a expor!",
    today_bonus: "Bonus de hoje",
    next_bonus: "Proximo bonus",
    friends_invited: "Amigos convidados", income_from_friends: "Renda de amigos",
    daily_bonus: "Bonus diario", consecutive_days: "Dias consecutivos",
    next_bonus: "Proximo bonus", claim_bonus: "Coletar bonus",
    complete_all: "Complete todas as tarefas diarias", all_tasks: "Bonus de todas as tarefas",
    discover: "Descobrir", achievements: "Conquistas",
    collect_5_artist: "Colecione 5 pinturas do mesmo artista",
    collect_5_year: "Colecione 5 pinturas do mesmo ano",
    same_artist: "Mesmo artista", same_year: "Mesmo ano",
    claim_rewards: "Coletar recompensas",
    subscribe_channel: "Inscrever-se no canal",
    subscribe_desc: "Inscreva-se no @privateart e ganhe moedas",
    subscribe_btn: "Inscrever-se",
    boost_channel: "Boost do canal", boost_desc: "Faca boost no @privateart",
    boost_btn: "Boost", per_boost: "por boost",
    gift_channel: "Presente ao canal",
    gift_desc: "Envie um presente para @privateart e ganhe moedas",
    gift_btn: "Presentear",
    one_time: "unica vez",
    discover_3_ref: "Convide 3 amigos", discover_5: "Descubra 5 pinturas",
    max_level: "MAX",
    delete_account: "Excluir conta",
    delete_confirm: "Excluir conta? Todos os dados serao perdidos permanentemente!",
    total_rating: "Rating total", your_rank: "Sua posicao",
    auction_desc: "Aqui voce podera vender suas pinturas para outros jogadores por Telegram Stars. O leilao sera aberto quando existirem 10 pinturas Masterpiece no jogo.",
    masterpiece_count: "Pinturas Masterpiece no jogo",
    leaderboard: "Classificacao",
    total_influence: "Influencia total das pinturas",
    welcome: "Bem-vindo!", first_painting: "Sua primeira pintura espera",
    tap_to_reveal: "Toque para revelar", skip_onboard: "Pular", continue_btn: "Continuar",
    loading: "Carregando...", error: "Erro", retry: "Tentar novamente",
    stars_payment: "Pagamento via Telegram Stars",
    collect_painting: "Coletar pintura",
    add_to_collection: "Adicionar a colecao", new_card: "Nova pintura!",
    no_cards: "Ainda sem pinturas", buy: "Comprar", cards: "Pinturas",
    language: "Idioma", owner: "Proprietario",
    same_artist_5: "Mesmo artista x5", same_year_5: "Mesmo ano x5",
    your_coins: "Suas moedas", painting_slots: "Espacos de pinturas",
    slots_full: "Todos os espacos cheios. Melhore os espacos",
    supply_tooltip: "Quantas desta pintura com este nivel existem",
    rarity_thresholds: "Limites de nível",
    condition_tooltip: "A condicao se deteriora com o tempo. Repare a pintura para restaura-la",
    max_rarity: "Nivel maximo alcancado!",
    sell: "Vender", sell_masterpiece_only: "Somente pinturas Masterpiece podem ser vendidas",
    collect: "Coletar",
    platinum: "Platina", gold: "Ouro", bronze: "Bronze",
    year: "Ano", rating: "Rating",
    hours_short: "h",
    tut_details: "Vamos descobrir que tipo de pintura e esta. Algumas pinturas podem valer muito!",
    tut_repair: "Toque para reparar",
    tut_exhibit: "Toque para comecar a ganhar moedas",
    tut_exhibit_pick: "Enquanto sua pintura esta em exibicao, ela ganha influencia e renda. A influencia aumenta o nivel da pintura, gerando recompensas maiores.",
    tut_buy: "Agora vamos comprar outra pintura — voce nunca sabe o que vai conseguir. Boa sorte!",
    level_upgraded: "Nivel da pintura melhorado",
    view_post: "Ver original", coming_soon_text: "Em breve...",
  },
};

export const SUPPORTED_LANGUAGES = ['en', 'ru', 'es', 'ar', 'uk', 'fr', 'pt'];

export const getTranslation = (lang, key) => {
  const l = SUPPORTED_LANGUAGES.includes(lang) ? lang : 'en';
  return translations[l]?.[key] || translations.en[key] || key;
};

export default translations;
